import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = ({ label = 'Back', sx = {} }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Button
      variant="outlined"
      onClick={handleBackClick}
      startIcon={<ArrowBackIcon />}
      sx={{
        color: '#1a1a2e',
        background: '#ffffff',
        border: '1.5px solid #1a1a2e',
        fontWeight: 700,
        textTransform: 'none',
        borderRadius: '10px',
        padding: '9px 20px',
        fontSize: '0.96rem',
        '&:hover': {
          color: '#0d4efe',
          background: '#ffffff',
          border: '1.5px solid #0d4efe',
        },
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};

export default BackButton;
